import { getStringSchema, getSelectSchema, getPercentSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';
import { AsOfSources } from '../../CasAsOf/AsOfSourcesSchema';

export const CMEAccountsSchema = Yup.object().shape({
  notes: getStringSchema(255, 'Notes').notRequired(),
  asOf: Yup.object().shape(
    {
      brokerId: getSelectSchema('Relationship Owner'),
      cmeCommScheduleId: getSelectSchema('Commission Schedule'),
      cmeAdditClearingId: getSelectSchema('Additional Clearing').notRequired(),
      asOfSources: AsOfSources,
      agreementEmployeeId: Yup.mixed().when('agreementPercent', {
        is: (agreementPercent: any) => agreementPercent != null,
        then() {
          return getSelectSchema('', 'Agreement Employee is required when Agreement% is entered.');
        },
        otherwise(schema) {
          return schema.notRequired();
        },
      }),
      agreementPercent: Yup.mixed().when('agreementEmployeeId', {
        is: (agreementEmployeeId: any) => agreementEmployeeId != null,
        then() {
          return getPercentSchema('Agreement%');
        },
        otherwise(schema) {
          return schema.notRequired().transform((value, originalValue) => {
            if (typeof originalValue === 'string' && originalValue.trim() === '') return null;
            return value;
          });
        },
      }),
    },
    [['agreementEmployeeId', 'agreementPercent']]
  ),
});
